
// import TaskView from "./task-view/task-view";
// import CollectionProto from "../../data-structures/depricated/collection-proto";
//
// // daz ne znau chto s etim poka delat'... poka ostavlu etu i eche odnu sdelau
// // po idee konechno tol'ko odna nuzna i model tol'ko odin nuzen ?
// // no stremno seichas trogat
//
// export default class TasksCollection extends CollectionProto<TaskView> {
//     constructor(models:any) {
//         super(models, TaskView);
//     }
// }


import Task from "./task";
import Collection from "../../data-structures/collection";
import Resources from "../../resources/resources";
import {GroupedData} from "../../data-structures/group";
import FieldProto from "../../fields3/proto/field-proto";
import groupByOperator from "../../data-structures/operators/group-by";
import {SortDirection} from "../../data-structures/sort";

export default class TasksCollection extends Collection<Task> {

    constructor(models:any) {
        super(models);
    }

    static initFromResources(resources: Resources):TasksCollection {
        return new TasksCollection(resources.tasks?.models)
    }

    static initFromJson(tasksData: JSONArray):TasksCollection {
        const models : Task[] = _.map(tasksData, (taskData:any)=>{
            return new Task(taskData)
        })

        return new TasksCollection(models)
    }

    add(model: Task) {
        if (this.get(model.id)) {
            this.replace(model.id, model)
        } else {
            super.add(model)
        }
    }

    // for Glist support
    public get items():any[] {
        return this.models
    }

    public search():TasksCollection {
        // need implementation
        return this
    }

    public filter():TasksCollection {
        // need implementation
        return this
    }

    public sort():TasksCollection {
        // need implementation
        return this
    }

    public groupBy(field:FieldProto, sortDirection:SortDirection=SortDirection.ASC):GroupedData {
        const groups: GroupedData = groupByOperator(this.models, field, sortDirection) as GroupedData
        return groups
    }

    get estimatedCostInternal() {
        let res = 0
        _.map(this.models, task=>{
            // res += calculateEstimatedCost(task.estimate, task.assignedToUserId).estimatedCostInternal
            res += task.estimatedCostInternal
        })
        return res
    }

    get estimatedCostExternal() {
        let res = 0
        _.map(this.models, task=>{
            // res += calculateEstimatedCost(task.estimate, task.assignedToUserId).estimatedCostExternal
            // res += calculateEstimatedServiceCost(task)
            res += task.estimatedCostExternal
        })
        return res
    }

    get estimateTotal() {
        let res = 0
        _.map(this.models, task=>{
            res += task.estimate || 0
        })
        return res
    }
}